import React, { useState } from "react";
import cx from "classnames";
import { Input } from "reactstrap";
import DropDown from "../DropDown/DropDown";
import { getSearchOptions } from "../../services/getSearchOptions";
import {
  getSelected,
  getButtonText,
  handleHotSpotFormFieldChange
} from "../../services/filters";
import { formSpotNamesConvertor } from "../../services/formNamesConvertor";
import { ModalConsumer } from "../../common/ModalContext";
import Button from "../../components/Button/Button";
import ModalWithDropDown from "../../components/ModalWithDropDown/ModalWithDropDown"
import {FIELDS_GREENSPOTS} from '../../constants/greenSpots'
import COUNTRIES from "../../constants/countries";
import { addNew } from "../../services/textsForm";
import styles from "../SpotForm/SpotForm.module.scss";
import greenSpotStyles from "./GreenSpotForm.module.scss";

const FirstStep = ({ state }) => {
  const [fieldActive, setFieldActive] = useState("problems");
  const {
    countries, setCountries,
    greenSpotFields,setGreenSpotFields,
    name, setName,
    address, setAddress,
    problem, setProblem,
    solutions, setSolutions,
    addFieldObject,
    validationError, setValidationError, changeValidationError, changeMultipleFieldsObject,type
  } = state
  const firstProblems = problem?.length?[...problem]:[]
  const lastProblem = firstProblems.pop();
  const firstSolutions = solutions?.length?[...solutions]:[]
  const lastSolutions = firstSolutions.pop()
  const cancelValidationError = (filterType) => {
    // MOVE TO SERVICES?
    setValidationError(
      validationError.filter((errorItem) => errorItem !== filterType)
    );
  };
  const getChangeFilterFunction = (modalId, value) => {
    ///MOVE TO SERVICES
    // eslint-disable-next-line default-case
    switch (modalId) {
      case "countries":
        setCountries(value);
        break;
      case "greenSpotFields":
        setGreenSpotFields(value);
        break;
    }
  };

  return (
    <div>
      <p className={greenSpotStyles.title}>General</p>
      <div className={greenSpotStyles.inlineForm}>
        <div className={greenSpotStyles.formItem}>
          <p className={greenSpotStyles.fieldLabel}>name green spot*</p>
          <p className={greenSpotStyles.fieldLabelText}>{addNew.titleText}</p>
          <Input
            name="name"
            placeholder={'Green Spot'}
            value={name}
            onChange={(event) => {
              setName(event.target.value);
              setValidationError(
                validationError.filter((errorItem) => errorItem !== "name")
              )
            }}
            className={cx(greenSpotStyles.input, {
              [greenSpotStyles.inputError]: validationError.includes("name"),
            })}
          />
        </div>
        <div className={cx(greenSpotStyles.formItem, greenSpotStyles.inlineSpace, greenSpotStyles.dropDown)}>
          <p className={greenSpotStyles.fieldLabel}>Fields*</p>
          <p className={greenSpotStyles.fieldLabelText}>{addNew.fieldTitleText}</p>
          <DropDown
            name={"greenSpotFields"}
            className={styles.autocomplete}
            changeValidationError={changeValidationError}
            onChange={handleHotSpotFormFieldChange.bind({
              filter: "greenSpotFields",
              changeFilter:setGreenSpotFields,
              selected:greenSpotFields,
              cancelValidationError: cancelValidationError,
            })}
            selected={greenSpotFields}
            onClear={() => setGreenSpotFields([])}
            dropDownErrorClass={
              validationError.includes("greenSpotFields") &&
              styles.dropDownError
            }
            options={FIELDS_GREENSPOTS.filter((option) => option.value !== "all")}
            buttonText={getButtonText(
              greenSpotFields,
              formSpotNamesConvertor("greenSpotFields"),
              "greenSpotFields"
            )}
          />
        </div>
      </div>

      <div>

        <div className={cx(styles.dropDownMobile, greenSpotStyles.spaceBlock)}>
          <ModalConsumer>
            {({ toggleModal }) => (
              <>
                <p
                  className={cx(styles.fieldLabel, {
                    [styles.labelError]:
                      validationError.includes("greenSpotFields"),
                  })}
                >
                  Fields*
                </p>
                <Button
                  onClick={() => {
                    toggleModal("greenSpotFields");
                  }}
                  className={cx(
                    styles.filterButton,
                    {
                      [styles.dropDownError]:
                        validationError.includes("greenSpotFields"),
                    },
                    greenSpotFields?.length
                      ? styles.labelValue
                      : styles.labelName
                  )}
                >
                  {getButtonText(
                    greenSpotFields,
                    formSpotNamesConvertor("greenSpotFields"),
                    "greenSpotFields"
                  )}
                </Button>
              </>
            )}
          </ModalConsumer>
        </div>
        <div className={cx(styles.dropDownMobile, greenSpotStyles.spaceBlock)}>
          <ModalConsumer>
            {({ toggleModal }) => (
              <>
                <p
                  className={cx(styles.fieldLabel, {
                    [styles.labelError]:
                      validationError.includes("countries"),
                  })}
                >
                  Countries*
                </p>
                <Button
                  onClick={() => {
                    toggleModal("countries");
                  }}
                  className={cx(
                    styles.filterButton,
                    {
                      [styles.dropDownError]:
                        validationError.includes("countries"),
                    },
                    countries?.length ? styles.labelValue : styles.labelName
                  )}
                >
                  {getButtonText(
                    countries,
                    formSpotNamesConvertor("countries"),
                    "countries"
                  )}
                </Button>
              </>
            )}
          </ModalConsumer>
        </div>
        <div className={cx(greenSpotStyles.inlineForm)}>
          <div className={cx(greenSpotStyles.dropDownDesktop, greenSpotStyles.dropDownCountries)}>
            <p className={greenSpotStyles.fieldLabel}>Countries*</p>
            <p className={greenSpotStyles.fieldLabelText}>{addNew.locationTitleText}</p>
            <DropDown
              name="countries"
              className={cx(styles.autocomplete)}
              changeValidationError={changeValidationError}
              onChange={handleHotSpotFormFieldChange.bind({
                filter: "countries",
                changeFilter: setCountries,
                selected: countries,
                cancelValidationError: cancelValidationError,
              })}
              selected={countries}
              onClear={() => setCountries([])}
              dropDownErrorClass={
                validationError.indexOf("countries") !== -1 &&
                styles.dropDownError
              }
              options={COUNTRIES.filter((option) => option.value !== "all")}
              buttonText={getButtonText(
                countries,
                formSpotNamesConvertor("countries"),
                "countries"
              )}
            />
          </div>
          {/* ADDRESS */}
          <div className={cx(greenSpotStyles.inlineSpace, greenSpotStyles.formItem)}>
            <p className={greenSpotStyles.fieldLabel}>address*</p>
            <p className={greenSpotStyles.fieldLabelText}>{addNew.addressTitleText}</p>
            <Input
              name="address"
              placeholder="Address"
              value={address}
              onChange={(event) => {
                setAddress(event.target.value);
                setValidationError(
                  validationError.filter((errorItem) => errorItem !== "address")
                )
              }}
              className={cx(greenSpotStyles.input, {
                [greenSpotStyles.inputError]: validationError.includes("address"),
              })}
            />
          </div>
        </div>
        <div className={greenSpotStyles.firstStepButtonsContainer}>
          <Button className={cx(greenSpotStyles.fieldsToggle, { [greenSpotStyles.fieldsToggleActive]: fieldActive === "problems" })} onClick={() => setFieldActive("problems")}>Problems</Button>
          <Button className={cx(greenSpotStyles.fieldsToggle, { [greenSpotStyles.fieldsToggleActive]: fieldActive === "solutions" })} onClick={() => setFieldActive("solutions")}>Solutions</Button>
        </div>
        {/* Problem */}
        
        {fieldActive === "problems" && <div className={styles.multipalFields}>
          {firstProblems?.map((problemItem, index) => (
            <div className={greenSpotStyles.fieldsBox} key={index}>
              <div className={greenSpotStyles.linkFormsText}>
                <div className={greenSpotStyles.formItem}>
                  <p className={greenSpotStyles.fieldLabel}>problem title</p>
                  <p className={greenSpotStyles.fieldLabelText}>{addNew.problemTitleText}</p>
                  <Input
                    name="problemTitle"
                    placeholder="Problem Title"
                    value={problemItem?.title}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        index,
                        setProblem,
                        problem
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "problem")
                      )
                    }}
                    className={cx(greenSpotStyles.input, {
                      [greenSpotStyles.inputError]: validationError.includes("problem"),
                    })}
                  />
                </div>
                <div className={styles.textareaContainer}>
                  <p className={greenSpotStyles.fieldLabel}>description problem</p>
                  <p className={cx(greenSpotStyles.fieldLabelTextTextarea, greenSpotStyles.fieldLabelText)}>{addNew.problemDescriptionText}</p>
                  <Input
                    className={cx(styles.textarea, {
                      [greenSpotStyles.inputError]: validationError.includes("problem"),
                    })}
                    type="textarea"
                    name="problemText"
                    placeholder="Problem Text"
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        index,
                        setProblem,
                        problem
                      );
                      setValidationError(
                        validationError.filter(
                          (errorItem) => errorItem !== "problem"
                        )
                      );
                    }}
                    value={problemItem?.text}
                  />
                  <p
                    className={cx(styles.errorLabel, {
                      "d-block": validationError.includes("problem"),
                    })}
                  >
                    {("error", "Please, add problem")}
                  </p>
                </div>
              </div>
            </div>
          ))}

          <div className={cx(greenSpotStyles.multipalFieldsContainer)}>
            <div className={greenSpotStyles.fieldsBox}>
              <div className={greenSpotStyles.linkFormsText}>
                <div className={greenSpotStyles.formItem}>
                  <p className={greenSpotStyles.fieldLabel}>problem title</p>
                  <p className={greenSpotStyles.fieldLabelText}>{addNew.problemTitleText}</p>
                  <Input
                    name="problemTitle"
                    placeholder="Problem Title"
                    value={lastProblem?.title ?? ""}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        problem.length - 1,
                        setProblem,
                        problem
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "problem")
                      )
                    }}
                    className={cx(greenSpotStyles.input, {
                      [greenSpotStyles.inputError]: validationError.includes("problem"),
                    })}
                  />
                </div>
                <div className={styles.textareaContainer}>
                  <p className={greenSpotStyles.fieldLabel}>description problem</p>
                  <p className={cx(greenSpotStyles.fieldLabelTextTextarea, greenSpotStyles.fieldLabelText)}>{addNew.problemDescriptionText}</p>
                  <Input
                    className={cx(styles.textarea, {
                      [greenSpotStyles.inputError]: validationError.includes("problem"),
                    })}
                    type="textarea"
                    name="problemText"
                    placeholder="Problem Text"
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        problem.length - 1,
                        setProblem,
                        problem
                      );
                      setValidationError(
                        validationError.filter(
                          (errorItem) => errorItem !== "problem"
                        )
                      );
                    }}
                    value={lastProblem?.text ?? ""}
                  />
                  <p
                    className={cx(styles.errorLabel, {
                      "d-block": validationError.includes("problem"),
                    })}
                  >
                    {("error", "Please, add problem")}
                  </p>
                </div>
              </div>

            </div>
            <Button
              className={greenSpotStyles.plusButton}
              onClick={() => addFieldObject(setProblem, problem)}
              disabled={!!lastProblem && !Object.keys(lastProblem).length}
            >
              +
            </Button>
          </div>
        </div>}
        {/* Solutions */}
        {fieldActive === "solutions" && <div className={greenSpotStyles.multiFields}>
          {firstSolutions?.map((solutionItem, index) => (
            <div className={greenSpotStyles.fieldsBox} key={index}>
              <div className={greenSpotStyles.linkFormsText}>
                <div className={greenSpotStyles.formItem}>
                  <p className={greenSpotStyles.fieldLabel}>solution name</p>
                  <p className={greenSpotStyles.fieldLabelText}>{addNew.solutionTitleText}</p>
                  <Input
                    name="solutionName"
                    placeholder="Solution Name"
                    value={solutionItem.name}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        index,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "solutions")
                      )
                    }}
                    className={cx(greenSpotStyles.input, {
                      [greenSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                  />
                </div>
                <div className={greenSpotStyles.formItem}>
                  <p className={greenSpotStyles.fieldLabel}>solution author</p>
                  <Input
                    name="solutionAuthor"
                    placeholder="Solution Author"
                    value={solutionItem.author}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        index,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "solutions")
                      )
                    }}
                    className={cx(greenSpotStyles.input, {
                      [greenSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                  />
                </div>
                <div className={greenSpotStyles.formItem}>
                  <p className={greenSpotStyles.fieldLabel}>solution link</p>
                  <Input
                    name="solutionLink"
                    placeholder="Solution Link"
                    value={solutionItem?.link ?? ""}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        index,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "solutions")
                      )
                    }}
                    className={cx(greenSpotStyles.input, {
                      [greenSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                  />
                </div>
                <div className={styles.textareaContainer}>
                  <p className={greenSpotStyles.fieldLabel}>solution text</p>
                  <p className={cx(greenSpotStyles.fieldLabelTextTextarea, greenSpotStyles.fieldLabelText)}>{addNew.solutionDescriptionText}</p>
                  <Input
                    className={cx(styles.textarea, {
                      [greenSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                    type="textarea"
                    name="solutionText"
                    placeholder="Solution Text"
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        index,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter(
                          (errorItem) => errorItem !== "solutions"
                        )
                      );
                    }}
                    value={solutionItem.text}
                  />
                  <p
                    className={cx(styles.errorLabel, {
                      "d-block": validationError.includes("solutions"),
                    })}
                  >
                    {("error", "Please, add solutions")}
                  </p>
                </div>
              </div>
            </div>
          ))}

          <div className={cx(greenSpotStyles.multipalFieldsContainer)}>
            <div className={greenSpotStyles.fieldsBox}>
              <div className={greenSpotStyles.linkFormsText}>
                <div className={greenSpotStyles.formItem}>
                  <p className={greenSpotStyles.fieldLabel}>solution name</p>
                  <p className={greenSpotStyles.fieldLabelText}>{addNew.solutionTitleText}</p>
                  <Input
                    name="solutionName"
                    placeholder="Solution Name"
                    value={lastSolutions?.name ?? ""}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        solutions.length - 1,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "solutions")
                      )
                    }}
                    className={cx(greenSpotStyles.input, {
                      [greenSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                  />
                </div>
                <div className={greenSpotStyles.formItem}>
                  <p className={greenSpotStyles.fieldLabel}>solution author</p>
                  <Input
                    name="solutionAuthor"
                    placeholder="Solution Author"
                    value={lastSolutions?.author ?? ""}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        solutions.length - 1,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "solutions")
                      )
                    }}
                    className={cx(greenSpotStyles.input, {
                      [greenSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                  />
                </div>
                <div className={greenSpotStyles.formItem}>
                  <p className={greenSpotStyles.fieldLabel}>solution link</p>
                  <Input
                    name="solutionLink"
                    placeholder="Solution Link"
                    value={lastSolutions?.link ?? ""}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        solutions.length - 1,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "solutions")
                      )
                    }}
                    className={cx(greenSpotStyles.input, {
                      [greenSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                  />
                </div>
                <div className={styles.textareaContainer}>
                  <p className={greenSpotStyles.fieldLabel}>solution text</p>
                  <p className={cx(greenSpotStyles.fieldLabelTextTextarea, greenSpotStyles.fieldLabelText)}>{addNew.solutionDescriptionText}</p>
                  <Input
                    className={cx(styles.textarea, {
                      [greenSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                    type="textarea"
                    name="solutionText"
                    placeholder="Solution Text"
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        solutions.length - 1,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter(
                          (errorItem) => errorItem !== "solutions"
                        )
                      );
                    }}
                    value={lastSolutions?.text ?? ""}
                  />
                  <p
                    className={cx(styles.errorLabel, {
                      "d-block": validationError.includes("solutions"),
                    })}
                  >
                    {("error", "Please, add solutions")}
                  </p>
                </div>
              </div>
            </div>
            <Button
              className={greenSpotStyles.plusButton}
              onClick={() => addFieldObject(setSolutions, solutions)}
              disabled={!!lastSolutions && !Object.keys(lastSolutions).length}
            >
              +
            </Button>
          </div>
        </div>}
      </div>

      <ModalConsumer>
        {({ isOpen, toggleModal, modalId }) => {
          return (
            (modalId === "countries" || // TO REFACTOR ONE OF
              modalId === "greenSpotFields" ||
              modalId === "businessFields" ||
              modalId === "category") && (
              <ModalWithDropDown
                onSave={toggleModal}
                toggleModal={toggleModal}
                isOpen={isOpen}
                name={modalId}
                options={modalId === "greenSpotFields" ? FIELDS_GREENSPOTS.filter(option => option.value !== "all") : getSearchOptions(modalId).filter(
                  (option) => option.value !== "all"
                )}
                selected={getSelected({
                  modalId,
                  countries,
                  greenSpotFields,
                })}
                onChange={handleHotSpotFormFieldChange.bind({
                  filter: modalId,
                  changeFilter: (value) =>
                    getChangeFilterFunction(modalId, value),
                  selected: getSelected({
                    modalId,
                    countries,
                    greenSpotFields,
                  }),
                  cancelValidationError: cancelValidationError,
                })}
                onClear={() => getChangeFilterFunction(modalId, [])}
                changeValidationError={changeValidationError}
              />
            )
          );
        }}
      </ModalConsumer>
    </div>
  )
}

export default FirstStep